// extracted by mini-css-extract-plugin
export default {"loadingSkeleton":"Gbff289","loading-skeleton":"G93a73b"};